import Lever from '@/api/lever'

export default {
  namespaced: true,
  state: {
    autoPost: false,
    autoApplicants: false,
    webhookUrl: '',
    authUsername: '',
    authPassword: '',
    authRegPassword: '',
    companyId: null,
    type: '',
    user: '',
    leverUsers: [],
    loading: false,
    disconnectLoading: false,
    leverConnected: false,
    feedbackMessage: null,
    error: false,
    gpLoading: false,
    currentCompany: {},
    leverAuth: null
  },
  mutations: {
    resetGreenhouseForm (state) {
      state.autoPost = false
      state.autoApplicants = false
      state.email = ''
      state.apiKey = ''
      state.webhookUrl = ''
      state.authUsername = ''
      state.authPassword = ''
      state.type = ''
      state.authRegPassword = ''
    },
    setAutoPost (state, autoPost) {
      state.autoPost = autoPost
    },
    setAutoApplicants (state, autoApplicants) {
      state.autoApplicants = autoApplicants
    },
    setWebhookUrl (state, webhookUrl) {
      state.webhookUrl = webhookUrl
    },
    setAuthUsername (state, authUsername) {
      state.authUsername = authUsername
    },
    setAuthPassword (state, authPassword) {
      state.authPassword = authPassword
    },
    setType (state, type) {
      state.type = type
    },
    setLoading (state, loading) {
      state.loading = loading
    },
    setLeverConnected (state, leverConnected) {
      state.leverConnected = leverConnected
    },
    setError (state, error) {
      state.error = error
    },
    setFeedbackMessage (state, feedbackMessage) {
      state.feedbackMessage = feedbackMessage
    },
    setAuthRegPassword (state, authRegPassword) {
      state.authRegPassword = authRegPassword
    },
    setGpLoading (state, gpLoading) {
      state.gpLoading = gpLoading
    },
    setCompanyId (state, companyId) {
      state.companyId = companyId
    },
    setDisconnectLoading (state, disconnectLoading) {
      state.disconnectLoading = disconnectLoading
    },
    setUser (state, user) {
      state.user = user
    },
    setCurrentCompany (state, currentCompany) {
      state.currentCompany = currentCompany
    },
    setLeverAuth (state, leverAuth) {
      state.leverAuth = leverAuth
    },
    setLeverUsers (state, leverUsers) {
      state.leverUsers = leverUsers
    }
  },
  actions: {
    async getLeverUsers ({commit, state}) {
      try {
        const {companyId, leverAuth} = state
        const res = await Lever.getUsers(companyId, leverAuth)
        commit('setLeverUsers', res.users)
        commit('setWebhookUrl', res.webHookUrl)
      } catch (e) {
        commit('setLeverAuth', null)
      }
    },
    async attachLever ({commit, state}) {
      try {
        commit('setLoading', true)
        const {autoPost, autoApplicants, user, type, companyId} = state
        const data = {
          receiveJobPost: autoPost,
          sendApplicants: autoApplicants,
          defaultJobTypeId: type,
          defaultPerformAsId: user
        }
        await Lever.attachLever(data, companyId)
        await Lever.checkLever(companyId)
        commit('setLoading', false)
        commit('setLeverConnected', true)
        commit('setFeedbackMessage', 'LEVER ATS CONNECTED')
      } catch (e) {
        commit('setLoading', false)
        commit('setError', true)
        commit('setFeedbackMessage', e.message)
      }
    },
    async disconnectLever ({commit, state}, {toggle}) {
      try {
        const {companyId} = state
        commit('setDisconnectLoading', true)
        await Lever.disconnectLever(companyId)
        commit('resetGreenhouseForm')
        commit('setLeverConnected', false)
        throw new Error('LEVER ATS DISCONNECTED')
      } catch (e) {
        commit('setDisconnectLoading', false)
        toggle()
        commit('setError', true)
        commit('setFeedbackMessage', e.message)
      }
    },
    async checkLeverStatus ({commit, state}) {
      try {
        const {companyId} = state
        commit('setLoading', true)
        const res = await Lever.checkLever(companyId)
        commit('setCurrentCompany', res)
        commit('setLeverConnected', true)
        commit('setLoading', false)
      } catch (e) {
        commit('setLeverConnected', false)
        commit('setLoading', false)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/lever.js